import React from "react";
import { Link } from "react-router-dom";
import { CalendarDays, MapPin, Lock } from "lucide-react";
import { EventStatusBadge } from "@/components/EventStatusBadge";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

const fmtDate = (iso) =>
  new Date(iso).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });

export function PremiumEventCard({ event }) {
  const soldOut = event.status === "sold_out";
  return (
    <Link
      to={`/event/${event.id}`}
      data-testid={`premium-card-${event.id}`}
      className="group block overflow-hidden rounded-2xl border border-border bg-card shadow-sm transition-transform duration-300 ease-in-out hover:-translate-y-1 hover:shadow-md"
    >
      <div className="relative aspect-[16/10] overflow-hidden">
        <img
          src={event.cover}
          alt={event.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-black/10" />
        <div className="absolute left-3 top-3 flex gap-2">
          <EventStatusBadge status={event.status} size="sm" />
        </div>
        <div className="absolute right-3 top-3 rounded-full bg-black/60 px-3 py-1 text-xs font-bold text-white backdrop-blur-md">
          {event.priceFrom === "Sold out" ? "Sold out" : `From ${event.priceFrom}`}
        </div>
        {/* Lock hint */}
        <div className="absolute bottom-3 left-3 flex items-center gap-1.5 text-xs font-medium text-white/90">
          <Lock className="h-3.5 w-3.5" /> Unlock to watch or attend
        </div>
      </div>
      <div className="space-y-3 p-5">
        <h3 className="line-clamp-1 font-heading text-lg font-bold tracking-tight text-foreground">
          {event.title}
        </h3>
        <div className="space-y-1.5 text-sm text-muted-foreground">
          <p className="flex items-center gap-2">
            <CalendarDays className="h-4 w-4 shrink-0 text-brand" />
            {fmtDate(event.startsAt)}
          </p>
          <p className="flex items-center gap-2">
            <MapPin className="h-4 w-4 shrink-0 text-brand" />
            {event.location.name}, {event.location.city}
          </p>
        </div>
        <div className="flex items-center justify-between pt-1">
          <div className="flex items-center gap-2">
            <Avatar className="h-7 w-7">
              <AvatarImage src={event.host.avatar} alt={event.host.displayName} />
              <AvatarFallback>{event.host.displayName[0]}</AvatarFallback>
            </Avatar>
            <span className="text-sm font-medium text-foreground">{event.host.displayName}</span>
          </div>
          <span
            className={`text-sm font-semibold ${soldOut ? "text-slate-400" : "text-brand"}`}
          >
            {soldOut ? "Waitlist" : "Unlock access"}
          </span>
        </div>
      </div>
    </Link>
  );
}

export default PremiumEventCard;
